module.exports = __webpack_public_path__ + "img/root101.8c415aa2.png";